var map = {
	"./fa-brands-400.woff2": 158,
	"./fa-duotone-900.woff2": 159,
	"./fa-light-300.woff2": 160,
	"./fa-regular-400.woff2": 161,
	"./fa-solid-900.woff2": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;